import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  recuperar: function(usuario) {
    return Vue.http.post('/api/login/recuperar', usuario);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha/servico.js